export const getTrackingQueryParams = () => {
    if (typeof window === "undefined") {
        return {
            av_medium: null,
            list_name: null,
        };
    }
    const queryParam = new URLSearchParams(window.location.search);
    return {
        av_medium: queryParam.get("m"),
        list_name: queryParam.get("ln"),
    };
};
